export { default as AtaReuniao } from "./AtaReuniao"
export { default as TableAtaReuniao } from "./TableAtaReuniao"
export { default as AtaReuniaoCreateForm } from "./AtaReuniaoCreateForm"
export { default as AtaReuniaoEditForm } from "./AtaReuniaoEditForm"
export { default as AtaReuniaoTrash } from "./AtaReuniaoTrash"
export { default as TableAtaReuniaoTrash } from "./TableAtaReuniaoTrash"



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/ata-reuniao/index.js